import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DialogConfirmDeleteComponent } from "./dialog-confirm-delete.component";
import { SharedModules } from "../../shared.modules";
import { ConfirmationModalComponent } from "../confirmation-modal/confirmation-modal.component";
@NgModule({
  declarations: [DialogConfirmDeleteComponent],
  imports: [CommonModule, SharedModules, ConfirmationModalComponent],
})
export class DialogConfirmDeleteModule {}
